/* global $ */
import React, { useState, useEffect, useRef } from 'react';
import axiosInstance from "../axiosInstance";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Footer from '../components/Footer';

function GstProduct() {
    const location = useLocation();

    const [products, setProducts] = useState([]); // Store product data
    const [newRecord, setNewRecord] = useState({ product_name: "", rate: "" });
    const [selectedProduct, setSelectedProduct] = useState(null); // Selected product for edit
    const [customerToDelete, setCustomerToDelete] = useState(null);
    const formRef = useRef(null);
    const [isDataTableInitialized, setIsDataTableInitialized] = useState(false);

    useEffect(() => {
        if (products.length > 0 && window.$) {
            let $ = window.$;

            if (isDataTableInitialized) {
                $(".datatable").DataTable().destroy();
            }

            $(".datatable").DataTable({
                "bFilter": false,
                "autoWidth": false,
                "sDom": "fBtlpi",
                "ordering": true,
                "columnDefs": [{ "targets": "no-sort", "orderable": false }],
                "language": {
                    search: " ",
                    sLengthMenu: "_MENU_",
                    paginate: {
                        next: 'Next <i className="fa fa-angle-double-right ms-2"></i>',
                        previous: '<i className="fa fa-angle-double-left me-2"></i> Previous',
                    },
                },
                initComplete: function () {
                    $(".dataTables_filter").appendTo("#tableSearch");
                    $(".dataTables_filter").appendTo(".search-input");
                },
            });

            setIsDataTableInitialized(true); // Mark DataTable as initialized
        }
    }, [products]);



    // Fetch Products
    const fetchProducts = async () => {
        try {
            const response = await axiosInstance.get("/gstproduct/");
            setProducts(response.data);
        } catch (error) {
            console.error("Error fetching Products:", error);
        }
    };

    // Fetch Products from API
    useEffect(() => {
        fetchProducts();
    }, []);

    // Open Edit Modal and Set Data
    const handleEditClick = (product) => {
        setSelectedProduct(product);
        setNewRecord({ product_name: product.product_name, hsncode: product.hsncode, gstrate: product.gstrate, product_name_tamil: product.product_name_tamil, phonetic_name: product.phonetic_name, rate: product.rate });
    };


    // Handle Form Input Change
    const handleChange = (e) => {
        setNewRecord({ ...newRecord, [e.target.name]: e.target.value });
    };

    // Handle Update Product
    const handleUpdate = async (e) => {
        e.preventDefault();
        if (!selectedProduct) return;
        console.log("update:", newRecord)

        try {
            await axiosInstance.put(`/gstproduct/${selectedProduct.id}`, { ...newRecord, modified_by: localStorage.getItem("user_id") });
            Swal.fire({
                title: "Updated!",
                text: "Product updated successfully!",
                icon: "success"
            }).then(() => {
                // Close the modal using jQuery
                $("#edit_product").modal("hide");
            });
            // Destroy DataTable before updating state
            if ($.fn.DataTable.isDataTable(".datatable")) {
                $(".datatable").DataTable().destroy();
            }

            // Fetch latest data and reinitialize DataTable
            await fetchProducts();
            setNewRecord({ product_name: "", rate: "" });
        } catch (error) {
            console.error("Error updating product:", error);
            Swal.fire("Error", "Failed to update product", "error");
        }
    };


    // Handle Delete Product
    const confirmDelete = async (e, product) => {
        e.preventDefault();
        if (!product) return;
        try {
            await axiosInstance.delete(`product/${product.id}`);
            setProducts(products.filter((product) => product.id !== product.id));
            Swal.fire({
                title: "Deleted!",
                text: "Product deleted successfully!",
                icon: "success"
            }).then(() => {
                // Close the modal using jQuery
                $("#delete_product").modal("hide");
            });
            // Destroy DataTable before updating state
            if ($.fn.DataTable.isDataTable(".datatable")) {
                $(".datatable").DataTable().destroy();
            }

            // Fetch latest data and reinitialize DataTable
            await fetchProducts();
        } catch (error) {
            console.error("Error deleting product:", error);
            Swal.fire("Error", "Failed to delete product", "error");
        }
    };

    // Handle Form Submission (Create)
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("enter")
        if (!formRef.current.checkValidity()) {
            console.log("isvalidating")
            formRef.current.classList.add("was-validated");
            return;
        }

        try {
            await axiosInstance.post("/gstproduct", { ...newRecord, created_by: localStorage.getItem("user_id") });
            Swal.fire("Created!", "The Product record has been created.", "success");
            // Destroy DataTable before fetching new data
            if ($.fn.DataTable.isDataTable(".datatable")) {
                $(".datatable").DataTable().destroy();
            }

            // Fetch latest data and reinitialize DataTable
            await fetchProducts();

            setNewRecord({ product_name: "", rate: "" });
            formRef.current.classList.remove("was-validated");
        } catch (error) {
            console.error("Error adding product:", error);
            Swal.fire("Error", "Failed to create product", "error");
        }
    };


    return (
        <div>
            {/* Page Wrapper */}
            < div className="page-wrapper" >
                <div className="content container-fluid">

                    {/* Page Header */}
                    <div className="page-header">
                        <div className="content-page-header ">
                            <h5>Products / Services</h5>
                            <div className="list-btn">
                                <ul className="filter-list">
                                    <li>
                                        <a className="btn btn-filters w-auto popup-toggle" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="Filter"><span className="me-2"><img src="assets/img/icons/filter-icon.svg" alt="filter" /></span>Filter </a>
                                    </li>
                                    <li className="">
                                        <div className="dropdown dropdown-action" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-original-title="Download">
                                            <a href="#" className="btn-filters" data-bs-toggle="dropdown" aria-expanded="false"><span><i className="fe fe-download"></i></span></a>
                                            <div className="dropdown-menu dropdown-menu-right">
                                                <ul className="d-block">
                                                    <li>
                                                        <a className="d-flex align-items-center download-item" href="javascript:void(0);" download><i className="far fa-file-pdf me-2"></i>PDF</a>
                                                    </li>
                                                    <li>
                                                        <a className="d-flex align-items-center download-item" href="javascript:void(0);" download><i className="far fa-file-text me-2"></i>CVS</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <a className="btn-filters" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="Print"><span><i className="fe fe-printer"></i></span> </a>
                                    </li>
                                    <li>
                                        <a className="btn btn-primary" href="#" data-bs-toggle="modal" data-bs-target="#add_products"><i className="fa fa-plus-circle me-2" aria-hidden="true"></i>Add Product</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* /Page Header */}

                    {/* All Invoice */}
                    <div className="card invoices-tabs-card">
                        <div className="invoices-main-tabs">
                            <div className="row align-items-center">
                                <div className="col-lg-12">
                                    <div className="invoices-tabs">
                                        <ul>
                                            <li><Link to="/product" className={location.pathname === "/product" ? "active" : ""}>Product</Link></li>
                                            <li><Link to="/gstproduct" className={location.pathname === "/gstproduct" ? "active" : ""}>GST Product</Link></li>
                                            <li><Link to="/units" className={location.pathname === "/units" ? "active" : ""}>Units</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /All Invoice */}

                    {/* Table */}
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card-table">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table table-center table-hover datatable">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th>#</th>
                                                    <th>Product Name</th>
                                                    <th>HSN Code</th>
                                                    <th>GST</th>
                                                    <th>Rate</th>
                                                    <th>Created On</th>
                                                    <th className="no-sort">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {products.length > 0 ? (
                                                    products.map((product, index) => {
                                                        return (
                                                            <tr key={product.id}>
                                                                <td>{index + 1}</td>
                                                                <td>{product.product_name}</td>
                                                                <td>{product.hsncode}</td>
                                                                <td>{product.gstrate}</td>
                                                                <td>{product.rate}</td>
                                                                <td>{product.createdAt ? new Date(product.createdAt).toLocaleDateString() : "N/A"}</td>
                                                                <td className="d-flex align-items-center">
                                                                    <button
                                                                        className="btn btn-greys bg-success-light me-2"
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#edit_product"
                                                                        onClick={() => handleEditClick(product)}
                                                                    >
                                                                        <i className="fa fa-edit me-1"></i>Edit
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-greys bg-danger-light me-2"
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#delete_product"
                                                                        onClick={(e) => confirmDelete(e, product)}
                                                                    >
                                                                        <i className="fa fa-trash-alt me-1"></i> Delete
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">
                                                            No Products found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Table */}
                </div>
                <Footer />
            </div >
            {/* /Page Wrapper */}

            {/* Add Products Modal */}
            <div className="modal custom-modal fade" id="add_products" role="dialog">
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header border-0 pb-0">
                            <div className="form-header modal-header-title text-start mb-0">
                                <h4 className="mb-0">Add Products</h4>
                            </div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">

                            </button>
                        </div>
                        <form ref={formRef} onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="input-block mb-3">
                                            <label>Product Name <span className="text-danger">*</span></label>
                                            <input type="text" name="product_name" value={newRecord.product_name} onChange={handleChange} className="form-control" placeholder="Enter Product Name" required />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="input-block mb-3">
                                            <label>HSN Code <span className="text-danger">*</span></label>
                                            <input type="text" name="hsncode" value={newRecord.hsncode} onChange={handleChange} className="form-control" placeholder="Enter HSN Code" required />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="input-block mb-3">
                                            <label>GST Rate <span className="text-danger">*</span></label>
                                            <input type="text" name="gstrate" value={newRecord.gstrate} onChange={handleChange} className="form-control" placeholder="Enter GST Rate" required />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="input-block mb-3">
                                            <label>Product Name Tamil </label>
                                            <input type="text" name="product_name_tamil" value={newRecord.product_name_tamil} onChange={handleChange} className="form-control" placeholder="Enter Tamil Product Name" />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="input-block mb-3">
                                            <label>Phonetic Name </label>
                                            <input type="text" name="phonetic_name" value={newRecord.phonetic_name} onChange={handleChange} className="form-control" placeholder="Enter Phonetic Name" />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="input-block mb-3">
                                            <label>Rate <span className="text-danger">*</span></label>
                                            <input type="number" name="rate" value={newRecord.rate} onChange={handleChange} className="form-control" placeholder="Enter Rate" required />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" data-bs-dismiss="modal" className="btn btn-back cancel-btn me-2">Cancel</button>
                                <button type="submit" data-bs-dismiss="modal" className="btn btn-primary paid-continue-btn">Add Product</button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
            {/* /Add Products Modal */}

            {/* Edit Products Modal */}
            <div className="modal custom-modal fade" id="edit_product" role="dialog">
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header border-0 pb-0">
                            <div className="form-header modal-header-title text-start mb-0">
                                <h4 className="mb-0">Edit Products</h4>
                            </div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">

                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-12 col-md-12">
                                    <div className="input-block mb-3">
                                        <label>Product Name <span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" name="product_name" value={newRecord.product_name} onChange={handleChange} placeholder="Enter Product Name" />
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12">
                                    <div className="input-block mb-3">
                                        <label>HSN Code <span className="text-danger">*</span></label>
                                        <input type="text" name="hsncode" value={newRecord.hsncode} onChange={handleChange} className="form-control" placeholder="Enter HSN Code" required />
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12">
                                    <div className="input-block mb-3">
                                        <label>GST Rate <span className="text-danger">*</span></label>
                                        <input type="text" name="gstrate" value={newRecord.gstrate} onChange={handleChange} className="form-control" placeholder="Enter GST Rate" required />
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12">
                                    <div className="input-block mb-3">
                                        <label>Product Name Tamil</label>
                                        <input type="text" name="product_name_tamil" value={newRecord.product_name_tamil} onChange={handleChange} className="form-control" placeholder="Enter Tamil Product Name" />
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12">
                                    <div className="input-block mb-3">
                                        <label>Phonetic Name</label>
                                        <input type="text" name="phonetic_name" value={newRecord.phonetic_name} onChange={handleChange} className="form-control" placeholder="Enter Phonetic Name" />
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12">
                                    <div className="input-block mb-3">
                                        <label>Rate <span className="text-danger">*</span></label>
                                        <input type="number" className="form-control" name="rate" value={newRecord.rate} onChange={handleChange} placeholder="Enter Rate" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" data-bs-dismiss="modal" className="btn btn-back cancel-btn me-2">Cancel</button>
                            <button type="submit" onClick={handleUpdate} className="btn btn-primary paid-continue-btn">Update</button>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Edit Products Modal */}

            {/* Delete Items Modal */}
            <div key={customerToDelete?.id} className="modal custom-modal fade" id="delete_product" role="dialog">
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="form-header">
                                <h3>Delete Products / Services</h3>
                                <p>Are you sure want to delete?</p>
                            </div>
                            <div className="modal-btn delete-action">
                                <div className="row">
                                    <div className="col-6">
                                        <button type="reset" className="w-100 btn btn-primary paid-continue-btn" onClick={(e) => { e.preventDefault(); confirmDelete(); }}>Delete</button>
                                    </div>
                                    <div className="col-6">
                                        <button type="submit" data-bs-dismiss="modal" className="w-100 btn btn-primary paid-cancel-btn">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Delete Items Modal */}

        </div>
    )
}

export default GstProduct